import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';

const RunZeroMappingForm = forwardRef(function RunZeroMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { organisationId, organisationName } = props.record;
      return [{id: organisationId, name: organisationName}]
    }
    return [];
  });
  const [form] = Form.useForm();

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects);
    }).catch(() => {
      message.error('Problem fetching organizations');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { organisationId } = config;
    const organisationName = find(projects, (obj) => obj.id === organisationId)?.name;

    return ({
      organisationId,
      organisationName,
    });
  }

  const extraFields = useMemo(() => ([
    {
      name: 'organisationId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Organization Name',
      options: projects,
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      form={form}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default RunZeroMappingForm;